import { EsFieldsOptions } from 'src/app/shared/base/EsFieldsOptions';
import { FieldOptions } from 'src/app/shared/base/FieldOptions';

export class CitesFormFields extends EsFieldsOptions {
  authorityLicenseNumber?: FieldOptions = {};
  transferType?: FieldOptions = {};
  availableType?: FieldOptions = {};
  ringNumber?: FieldOptions = {};
  balanceType?: FieldOptions = {};
  quantity?: FieldOptions = {};
  termsAndConditionsAgreement?: FieldOptions = {};
  termsAndConditionsAgreementReplace?: FieldOptions = {};
  registeredQuantity?: FieldOptions = {};
  measurementUnit?: FieldOptions = {};
  certificateNumber?: FieldOptions = {};
  newFalcon?: FieldOptions = {};
  expiredPassport?: FieldOptions = {};
  validPassport?: FieldOptions = {};
  type?: FieldOptions = {};
  gender?: FieldOptions = {};
  originCountry?: FieldOptions = {};
  source?: FieldOptions = {};
  appendix?: FieldOptions = {};
  chipNumber?: FieldOptions = {};
  class?: FieldOptions = {};
  oldPassportNumber?: FieldOptions = {};
  procedureInstanceId?: FieldOptions = {};
  requestId?: FieldOptions = {};
  requestType?: FieldOptions = {};
  receiverEmirate?: FieldOptions = {};
  deliveryType?: FieldOptions = {};
  receiverRegion?: FieldOptions = {};
  mobileNumber?: FieldOptions = {};
  addressDetails?: FieldOptions = {};
  scientificNameOther?: FieldOptions = {};
}
